import { render } from "./NewsletterPage.vue?vue&type=template&id=5877d973&scoped=true"
import script from "./NewsletterPage.vue?vue&type=script&lang=js"
export * from "./NewsletterPage.vue?vue&type=script&lang=js"

import "./NewsletterPage.vue?vue&type=style&index=0&id=5877d973&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5877d973"]])

export default __exports__